/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Previous_SlideInputs */



/**
* | output |
* | --- |
* | "Previous slide" |
*
* @param {Previous_SlideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const previous_slide = /** @type {((inputs?: Previous_SlideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previous_SlideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Diapositive précédente")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorherige Folie")
	if (locale === "it") return /** @type {LocalizedString} */ ("Diapositiva precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предыдущий слайд")
	if (locale === "es") return /** @type {LocalizedString} */ ("Diapositiva anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上一张幻灯片")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前のスライド")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछली स्लाइड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Slide anterior")
	return /** @type {LocalizedString} */ ("Previous slide")
});